import React, {Component} from "react"
import {connect} from "react-redux";
import withStyles from "@mui/styles/withStyles";
import {Box, FormControl} from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Validator from "../utilities/validator";
import Button from "@mui/material/Button";
import {remove_account} from "../actions/auth";
import SnackbarMessage from "./Custom/SnackbarMessage";

const styles = {

    root: {
        marginTop: 15,
        marginLeft: 15,
        marginRight: 15,
        minHeight: "calc(100vh - 88px)",
        position: "relative"
    },
};


class ProfileTermination extends Component {
    constructor(props) {
        super(props);
        this.state = {
            password: "",
            passwordTouched: true,
            error: null
        };
    }


    onSubmit(e) {
        e.preventDefault();
        if (this.state.password.length === 0 || !Validator.isPasswordValid(this.state.password)) {
            this.setState({
                ...this.state,
                passwordTouched: true
            });
        } else {

            this.props.remove_account(this.state.password).then((res) => {
                this.props.history.push("/logout");
            }).catch(err => {
                if (typeof err.response.data.message !== "undefined") {
                    this.setState({
                        ...this.state,
                        error: err.response.data.message
                    });
                } else {
                    this.setState({
                        ...this.state,
                        error: err.response.data.error
                    });
                }
            });
        }
    };

    onChange = e => this.setState({
        ...this.state,
        [e.target.name]: e.target.value,
        [e.target.name + 'Touched']: true
    });

    clearError() {
        this.setState({
            ...this.state,
            error: null
        });
    }

    render() {
        const {classes} = this.props;
        return (
            <Box
                className={classes.root}>
                <Grid container
                      direction="row"
                      justifyContent="center"
                      alignItems="flex-start"
                >
                    <Grid item xs={12} md={6}>
                        <div>
                            <Typography variant={"h5"}
                                        style={{marginBottom: 30}}>Profile Termination</Typography>

                            {this.state.error && <SnackbarMessage onClose={this.clearError.bind(this)} type="error"
                                                                  message={this.state.error} autoHideDuration={null}
                                                                  anchorOrigin={false}
                                                                  style={{marginBottom: 30}}/>}

                            <form onSubmit={this.onSubmit.bind(this)}>
                                <Grid container
                                      justifyContent="flex-end">
                                    <Grid item xs={12} md={12}>
                                        <TextField fullWidth className={classes.password}
                                                   variant="standard"
                                                   label="Enter your current password"
                                                   type="password"
                                                   name="password" onChange={this.onChange} value={this.state.password}
                                                   error={this.state.passwordTouched && !Validator.isPasswordValid(this.state.password)}
                                                   helperText={this.state.passwordTouched && !Validator.isPasswordValid(this.state.password) ? "Minimum 8 characters, at least one uppercase letter, one lowercase letter and one number" : ""}
                                        />
                                    </Grid>
                                    <Grid style={{paddingTop: 15, justifyContent: "space-between"}} container>
                                        <Grid item xs={8}>Note please, entire profile including the content of your
                                            profile will be permanently deleted.</Grid>
                                        <Grid item xs={2}>
                                            <FormControl>
                                                <Button variant="contained"
                                                        onClick={this.onSubmit.bind(this)}
                                                        disabled={this.state.password.length === 0 || !Validator.isPasswordValid(this.state.password)}
                                                        color="secondary"
                                                        type="submit"
                                                >Delete</Button>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </form>
                        </div>
                    </Grid>
                </Grid>
            </Box>
        );
    }
}

const mapStateToProps = state => ({});

export default withStyles(styles)(connect(
    mapStateToProps,
    {remove_account}
)(ProfileTermination));
